import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-arrow",
  "use": "icon-icon-arrow-usage",
  "viewBox": "0 0 16 15",
  "content": "<symbol viewBox=\"0 0 16 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-arrow\">\n<rect y=\"6\" width=\"15\" height=\"2.5\" fill=\"white\" />\n<path d=\"M8.75 1L15 7.25L8.75 13.5\" stroke=\"white\" stroke-width=\"2\" stroke-linejoin=\"bevel\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol